/**
 * SignInScreen — fallback UI shown by `RequireAuth` during the interactive
 * authentication phase (task 3.13, 5.7; Req 1.1, 1.2, 15.4, 25.5).
 *
 * The `@viamericas/auth-react` `RequireAuth` component drives the sign-in
 * redirect automatically. This screen is rendered as the `fallback` prop while
 * that flow is in progress or when initialization fails. It shows a centered
 * white card on the neutral canvas with a "Signing in…" indication. The library
 * handles the actual redirect — this is purely the UI placeholder.
 *
 * Design-system styling: centered white card on neutral canvas, heading/medium
 * title, blue primary button, Roboto (Req 25.5, 26.2, 26.3).
 */

/**
 * A minimal, design-system-styled screen displayed while the auth provider is
 * performing or awaiting interactive sign-in. If initialization failed, it
 * shows a friendly message.
 */
export default function SignInScreen() {
  return (
    <div className="auth-screen" role="main" aria-label="Sign in">
      <div className="auth-card">
        <h1 className="auth-card__title">Scan Results Dashboard</h1>
        <p className="auth-card__message">Signing in to your Viamericas account…</p>
        <div className="auth-card__spinner" role="status" aria-label="Loading">
          <span className="auth-card__dot" />
          <span className="auth-card__dot" />
          <span className="auth-card__dot" />
        </div>
      </div>
    </div>
  );
}
